var _path, _path2, _g, _g2, _g3, _g4, _path3, _g5, _path4, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropBankPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 77,
    viewBox: "0 0 317 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.38 6.27761H233.444C231.46 4.21934 229.452 2.13639 228.344 0.986328H88.3471C87.3765 1.99325 85.2639 4.18479 83.2465 6.27761H21.3156C17.9707 9.74755 16.096 11.6923 12.751 15.1622V66.2833L21.3156 75.1679H295.38C298.725 71.698 300.6 69.7533 303.945 66.2833V15.1622C300.6 11.6923 298.725 9.74755 295.38 6.27761Z",
    fill: "url(#paint0_radial_318_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.38 6.27761H233.444C231.46 4.21934 229.452 2.13639 228.344 0.986328H88.3471C87.3765 1.99325 85.2639 4.18479 83.2465 6.27761H21.3156L12.751 15.1622V66.2833C16.096 69.7533 17.9707 71.698 21.3156 75.1679H295.38C298.725 71.698 300.6 69.7533 303.945 66.2833V15.1622L295.38 6.27761Z",
    fill: "url(#paint1_radial_318_3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.014 11.2052C88.014 11.2052 90.0648 9.07293 93.1052 5.92383H223.581C225.727 8.14992 226.526 8.97915 228.672 11.2052H88.014Z",
    fill: "#EFBA3D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.186 63.0059C297.312 64.8025 296.479 65.6959 292.092 70.2468H24.5985C20.2116 65.6959 21.8912 67.5568 17.5043 63.0059",
    stroke: "#21A0A9",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.622 11.1992H292.092C296.479 15.7501 294.799 14.0176 299.186 18.5685",
    stroke: "#78FFF8",
    strokeOpacity: 0.72,
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.509 18.6129C21.896 14.062 20.2164 15.7501 24.6033 11.1992H78.9974",
    stroke: "#78FFF8",
    strokeOpacity: 0.72,
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303 19C303 19 309.851 23.0489 313 24L313 56.5L303 63L303 19Z",
    fill: "url(#paint2_linear_318_3)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 23L308 25.5L308 55L302 58.9704L302 23Z",
    fill: "#EFBA3D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L2.99996 24L2.99996 56.5L13 63L13 19Z",
    fill: "url(#paint3_linear_318_3)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_318_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 23L7.99996 25.5L7.99996 55L14 58.9704L14 23Z",
    fill: "#EFBA3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_318_3",
    x: 86.0584,
    y: 3.96816,
    width: 144.569,
    height: 9.19275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_318_3",
    x: 15.1819,
    y: 60.6835,
    width: 286.327,
    height: 11.8857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3375 0 0 0 0 1 0 0 0 0 0.966417 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_318_3",
    x: 235.299,
    y: 8.87685,
    width: 66.2093,
    height: 12.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3375 0 0 0 0 1 0 0 0 0 0.966417 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_318_3",
    x: 15.1867,
    y: 8.87685,
    width: 66.1331,
    height: 12.0584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3375 0 0 0 0 1 0 0 0 0 0.966417 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_318_3",
    x: 300.044,
    y: 21.0443,
    width: 9.91139,
    height: 39.8817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_318_3",
    x: 6.04429,
    y: 21.0443,
    width: 9.91138,
    height: 39.8817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_318_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_318_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_318_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.526 26.7377) scale(197.407 79.8663)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#8385D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#4244B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#333580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_318_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.268 -18.1178) scale(154.038 30.361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C2EAFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEE7FD",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B6E4FB",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ACDEF9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A1D9F7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#98D5F6",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3AB0ED",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A2EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_3",
    x1: 305.641,
    y1: 19,
    x2: 305.641,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05238D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_3",
    x1: 10.3593,
    y1: 19,
    x2: 10.3593,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0845AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06319A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropBankPanel);
export default __webpack_public_path__ + "static/media/drop-bank-panel.f2f2023838516d25f5cd033112296c7e.svg";
export { ForwardRef as ReactComponent };